import { Typography } from "@mui/material";
import theme from "../../muiTheme";

export interface EnvirormentContentProps {
  service: string;
  variant: "subtitle1" | "body1" | "body2";
  showServiceText?: boolean;
}

const EnvirormentContent = ({
  service,
  variant,
  showServiceText = true,
}: EnvirormentContentProps) => {
  const serviceContent = () => {
    switch (service.toLocaleLowerCase()) {
      case "luz":
        return {
          backgroundColor: theme.palette.background.electricity,
          classNameIcon: "t-icon-electricite",
        };
      case "gas":
        return {
          backgroundColor: theme.palette.background.gas,
          classNameIcon: "t-icon-gaz",
        };
      default:
        return { backgroundColor: "", classNameIcon: "" };
    }
  };

  const { classNameIcon, backgroundColor } = serviceContent();

  return (
    <Typography
      variant={variant}
      component="span"
      width={"fit-content"}
      sx={{
        backgroundImage: backgroundColor,
        backgroundSize: "100%",
        backgroundRepeat: "repeat",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
      }}
    >
      <span
        aria-hidden="true"
        className={classNameIcon}
        style={{ paddingRight: ".25rem" }}
      />
      {showServiceText && service}
    </Typography>
  );
};

export default EnvirormentContent;
